import { apiSlice } from "../stores/base/api-slice";
import { ConsumerType } from "../model/energy-profile";

const serviceBaseurl = "/vending/beneficiary";

export interface BeneficiaryItem {
	id: string;
	customerName: string;
	type: ConsumerType;
	identifier: string;
	address?: string;
	createdAt: string;
	lastPurchase?: string;
}

export interface SaveBeneficiaryPayload {
	type: ConsumerType;
	identifier: string;
}

const beneficiaryEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getBeneficiaries: builder.query<BeneficiaryItem[], void>({
			providesTags: ["Beneficiaries"],
			query: () => ({
				url: serviceBaseurl,
				method: "GET",
			}),
		}),
		getBeneficiaryById: builder.query<BeneficiaryItem, string>({
			providesTags: ["Beneficiaries"],
			query: id => ({
				url: `${serviceBaseurl}/${id}`,
				method: "GET",
			}),
		}),
		saveBeneficiary: builder.mutation<string, SaveBeneficiaryPayload>({
			invalidatesTags: ["Beneficiaries"],
			query: body => ({
				url: serviceBaseurl,
				method: "POST",
				body,
			}),
		}),
		deleteBeneficiary: builder.mutation<void, string>({
			invalidatesTags: ["Beneficiaries"],
			query: id => ({
				url: `${serviceBaseurl}?id=${encodeURIComponent(id)}`,
				method: "DELETE",
			}),
		}),
	}),
});

export const {
	useGetBeneficiariesQuery,
	useLazyGetBeneficiariesQuery,
	useGetBeneficiaryByIdQuery,
	useSaveBeneficiaryMutation,
	useDeleteBeneficiaryMutation,
} = beneficiaryEndpoints;
